module.exports = __webpack_public_path__ + "static/media/circulo_FFB94C.2fb9de1d.svg";